/**
 * Os painéis dos Catálogos que precisam de algo além do componente cru.
 *
 * Mora fora do `itens-registry.tsx` pela mesma razão que os wrappers de
 * orçamento: um arquivo que exporta componentes **e** um mapa quebra o fast
 * refresh.
 */
import { RequireProfile } from '@/components/RequireProfile';
import { TELA_SLUGS_VISIVEIS } from '@/lib/use-pode-editar';
import type { ProfileSlug } from '@/lib/admin-types';
import { CatalogsR2Page } from '@/pages/admin/CatalogsR2Page';
import { CatalogTable } from '@/pages/admin/CatalogsPage';

/**
 * Catálogos "Avançados" — a guarda viaja JUNTO com a tela.
 *
 * Na tela antiga o gate ficava **fora** do componente: a aba só era renderizada
 * se `isSuperAdmin || profile.slug === 'administrativo'`. `CatalogsR2Page` não
 * se protege sozinha — mover só o componente teria aberto a tela para qualquer
 * admin, e migração não pode alargar acesso em silêncio.
 *
 * Reusa `RequireProfile` + `TELA_SLUGS_VISIVEIS['catalogs-r2']`, que é a mesma
 * matriz que a tela antiga consultava (super-admin sempre passa), em vez de
 * recopiar a condição — condição copiada é condição que diverge.
 *
 * ⚠️ Dívida conhecida: acesso deveria se decidir na tela de Permissões, não por
 * allowlist de perfil no código. Isto PRESERVA o comportamento de hoje; a
 * conversão para chave de acesso é assunto da rodada R-PERMISSOES-ACESSO.
 */
export function CatalogosAvancados() {
  return (
    <RequireProfile slugs={TELA_SLUGS_VISIVEIS['catalogs-r2'] as ProfileSlug[]}>
      <CatalogsR2Page />
    </RequireProfile>
  );
}

/**
 * As três listas do Comercial — Produtos, Serviços e Origens.
 *
 * Na tela antiga eram uma sidebar de três botões trocando a prop `list` da
 * mesma `CatalogTable`. Aqui cada uma ganha endereço próprio, e a tabela
 * continua sendo **uma implementação só**: copiá-la por item criaria três
 * lugares para consertar o mesmo bug de arrasto ou de contagem de uso.
 *
 * Sem `flag`: o Comercial não depende de módulo ligado — é a área que a casa
 * usa todo dia.
 */
export function CatalogoProdutos() {
  return <CatalogTable dept="comercial" list="produtos" />;
}

export function CatalogoServicos() {
  return <CatalogTable dept="comercial" list="servicos" />;
}

export function CatalogoOrigens() {
  return <CatalogTable dept="comercial" list="origens" />;
}
